export default __webpack_public_path__ + "static/media/banner_price.3aa9c461.webp";